import React, { useState, useEffect, useRef } from 'react'

import { Container, Tab, Nav, Row, Col, Spinner, Form, Overlay, Tooltip } from 'react-bootstrap'

import ExploreCommunity from './ExploreCommunity'
import ExploreEvent from './ExploreEvent'
import { ReactComponent as SearchIcon } from '../img/search.svg'
import { ReactComponent as PlusIcon } from '../img/plus.svg'
import './Explore.css'
import { apiSearchCommunities, apiGetAllCommunities, apiGetEvents, apiSearchEvents } from '../api/api';


const ExploreNew = () => {

  const [community, setCommunity] = useState([])
  const [isFetchingCommunity, SetIsFetchingCommunity] = useState(true)
  const [isFetchingEvent, SetIsFetchingEvent] = useState(true)
  const [events, setEvents] = useState([])

  const [selectedTab, setSelectedTab] = useState(0)

  const [isSearching, setIsSearching] = useState(false);
  const [inputName, setInputName] = useState('')
  const [isCreateButtonActive, setIsCreateButtonActive] = useState(false)
  const target = useRef(null);

  const handleSubmit = async (event) => {
    setIsSearching(true)
    event.preventDefault()

    if (selectedTab === 0){
      fetchSearchedCommunity(inputName, 0, 1000)
    }else if (selectedTab === 1){
      fetchSearchedEvents(inputName)
    }
  }

  const handleNameChange = (event) => {
    setInputName(event.target.value)
  }

  //Communities methods
  const fetchCommunity = async (skip, limit) => {
    const result = await apiGetAllCommunities(skip, limit);
    setCommunity(result.data)
    SetIsFetchingCommunity(false)
  }

  const fetchSearchedCommunity = async (name, skip, limit) => {
    const result = await apiSearchCommunities(name, skip, limit)
    setCommunity(result.data)
    setIsSearching(false)
    SetIsFetchingCommunity(false)
  }

  //Events methods
  const fetchEvents = async () => {
    const result = await apiGetEvents(0, 1000)
    setEvents(result.data.content)
    SetIsFetchingEvent(false)
  }

  const fetchSearchedEvents = async (name) => {
    const result = await apiSearchEvents(name, 0, 1000)
    setEvents(result.data.content)
    setIsSearching(false)
  }

  const tabChange = (selected) => {
    setSelectedTab(selected)
    console.log("selected tab" + selectedTab)
  }

  useEffect(() => {
    fetchCommunity(0, 1000)
    fetchEvents()
  }, [])

  return (
    <Container id="explore-new">
      <Tab.Container id="left-tabs-example" defaultActiveKey="first">
        <Row className='justify-content-center'>
          <Col className="tab-buttons" style={{ display: 'flex', justifyContent: 'center' }}>
            <Nav variant="pills" className="d-flex" >
              <Nav.Item onClick={() => {tabChange(0)}}>
                <Nav.Link eventKey="first">Community</Nav.Link>
              </Nav.Item>
              <Nav.Item data-testid="event-tab-button-test-id" onClick={() => {tabChange(1)}}>
                <Nav.Link eventKey="second">Event</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
        </Row>
        <Row>
          <Form onSubmit={handleSubmit} data-testid="search-form">
            <Form.Group className="mb-3">
              <Row style={{ marginBottom: '2vh', marginTop: '2vh' }}>
                <Col style={{ width: '15vw', display: 'flex', justifyContent: 'center' }}>
                  <div className='searchbar-container'>
                    <Form.Control data-testid="input-search-community-name" value={inputName} type="text" name="name" onChange={handleNameChange} placeholder="Search..." style={{ width: '50vw', borderTopRightRadius: '0px', borderBottomRightRadius: '0px' }}></Form.Control>
                    <span className='search-icon-container'>{isSearching ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : <SearchIcon onClick={handleSubmit} className="search-icon" data-testid="search-icon-test-id"></SearchIcon>}</span>
                  </div>
                </Col>
              </Row>
            </Form.Group>
          </Form>
        </Row>
        <Row>
          <Col xs={12}>
            <Tab.Content>
              <Tab.Pane eventKey="first">{
                isFetchingCommunity ?
                  <div className='middle-spinner-container'><Spinner animation="border" variant="warning" style={{ width: "10rem", height: "10rem" }}/></div> :
                  <ExploreCommunity community={community} />
                }
              </Tab.Pane>
              <Tab.Pane eventKey="second">{
                isFetchingEvent ?
                <div className='middle-spinner-container'><Spinner animation="border" variant="warning" style={{ width: "10rem", height: "10rem" }}/></div> :
                <ExploreEvent events={events} />
              }
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
      <div className='create-button' data-testid="create-button" ref={target} onClick={() => {setIsCreateButtonActive(!isCreateButtonActive)}}>
        <div className='plus-container'>
          {isCreateButtonActive? <PlusIcon id='plus-tilted'></PlusIcon>:<PlusIcon id='plus-normal'></PlusIcon>}
        </div>
      </div>
      <Overlay target={target.current} show={isCreateButtonActive} placement="top">
        {(props) => (
          <Tooltip id="overlay-create" {...props}>
            <a href="/community/create" className='create-links' id='create-community-link'>Create Community</a>
            <hr></hr>
            <a href="/event/create" className='create-links' id='create-event-link'>Create Event</a>
          </Tooltip>
        )}
      </Overlay>
    </Container>
  )
}

export default ExploreNew